(function(){

var SAMM_SECS=[
  {id:'gov',label:'Governance',short:'Gobierno',samm:'SAMM: Strategy, Policy, Education',iso:'A.5, A.6'},
  {id:'des',label:'Design',short:'Diseño',samm:'SAMM: Threat Assessment, Security Requirements',iso:'A.8.25-A.8.27'},
  {id:'imp',label:'Implementation',short:'Implementación',samm:'SAMM: Secure Build, Defect Management',iso:'A.8.28'},
  {id:'ver',label:'Verification',short:'Verificación',samm:'SAMM: Architecture Review, Security Testing',iso:'A.8.29'},
  {id:'ops',label:'Operations',short:'Operaciones',samm:'SAMM: Incident Management, Environment Management',iso:'A.8.30-A.8.32'}
];

var SAMM_REF={
  gov:{l1:40,l2:70},des:{l1:40,l2:70},imp:{l1:40,l2:70},ver:{l1:40,l2:70},ops:{l1:40,l2:70}
};

var LEVEL_COLOR={'Crítico':'#dc2626','Alto':'#ef4444','Medio':'#d97706','Bajo':'#16a34a'};
var EFFORT_COLOR={'Bajo':'#16a34a','Medio':'#d97706','Alto':'#dc2626'};

function gid(id){return document.getElementById(id);}
function radio(name){var el=document.querySelector('input[name="'+name+'"]:checked');return el?parseInt(el.value):0;}
function txt(id){var el=gid(id);return el?el.value.trim():'';}
function badge(t,c){return '<span class="psq-badge" style="background:'+c+'22;color:'+c+';border:1px solid '+c+'55">'+t+'</span>';}
function scoreColor(s){return s>=70?'#16a34a':s>=40?'#d97706':'#dc2626';}
function scoreLbl(s){return s>=70?'Madurez Alta':s>=40?'Madurez Media':'Madurez Baja';}
function sammLevel(s){return s>=70?'Nivel 2+':s>=40?'Nivel 1':'Nivel 0';}
function scrollToTop(){var root=gid('psq-root');if(root){var t=root.getBoundingClientRect().top+window.pageYOffset-16;window.scrollTo({top:t,behavior:'smooth'});}}

function computeSAMM(){
  var qs={
    gov:[radio('sg1'),radio('sg2'),radio('sg3'),radio('sg4'),radio('sg5')],
    des:[radio('sd1'),radio('sd2'),radio('sd3'),radio('sd4'),radio('sd5')],
    imp:[radio('si1'),radio('si2'),radio('si3'),radio('si4'),radio('si5')],
    ver:[radio('sv1'),radio('sv2'),radio('sv3'),radio('sv4'),radio('sv5')],
    ops:[radio('so1'),radio('so2'),radio('so3'),radio('so4'),radio('so5')]
  };
  var sc={};
  Object.keys(qs).forEach(function(k){
    var arr=qs[k],sum=arr.reduce(function(a,b){return a+b;},0);
    sc[k]=Math.round((sum/(arr.length*2))*100);
  });
  return sc;
}

function overallSAMM(sc){
  return Math.round(Object.keys(sc).map(function(k){return sc[k];}).reduce(function(a,b){return a+b;},0)/5);
}

function buildSAMMRisks(sc){
  var R=[];
  var add=function(c,r){if(c)R.push(r);};

  add(sc.gov<40,{sev:sc.gov<20?'Crítico':'Alto',dom:'Governance',practica:'Strategy & Metrics',
    title:'Sin estrategia de seguridad del software',
    desc:'La ausencia de gobierno de AppSec implica que las decisiones de seguridad son ad hoc y no sistemáticas.',
    impact:'Vulnerabilidades recurrentes, sin mejora sostenida de la madurez.',samm:'SAMM SM1-2'});
  add(sc.gov<40&&radio('sg3')===0,{sev:'Alto',dom:'Governance',practica:'Education & Guidance',
    title:'Ausencia de formación en seguridad para desarrolladores',
    desc:'Sin formación, los desarrolladores introducen vulnerabilidades evitables por desconocimiento.',
    impact:'Alto ratio de vulnerabilidades en code review y pentests.',samm:'SAMM EG1'});
  add(sc.des<40,{sev:sc.des<20?'Crítico':'Alto',dom:'Design',practica:'Threat Assessment',
    title:'Sin modelado de amenazas en el diseño',
    desc:'Sin Threat Modeling, las aplicaciones se diseñan sin considerar los vectores de ataque relevantes.',
    impact:'Vulnerabilidades arquitectónicas difíciles y costosas de corregir en fases tardías.',samm:'SAMM TA1-2'});
  add(radio('sd2')===0,{sev:'Alto',dom:'Design',practica:'Security Requirements',
    title:'Sin requisitos de seguridad formalizados',
    desc:'La ausencia de requisitos de seguridad impide verificar el cumplimiento antes del paso a producción.',
    impact:'Funcionalidades inseguras llegan a producción sin revisión.',samm:'SAMM SR1'});
  add(radio('sd4')===0,{sev:'Alto',dom:'Design',practica:'Security Architecture',
    title:'Sin evaluación de componentes de terceros',
    desc:'Las dependencias no evaluadas son el principal vector de supply chain attacks.',
    impact:'Exposición a vulnerabilidades conocidas en librerías. Riesgo de supply chain attack.',samm:'SAMM SA1'});
  add(sc.imp<40,{sev:sc.imp<20?'Crítico':'Alto',dom:'Implementation',practica:'Secure Build',
    title:'Pipeline de CI/CD sin controles de seguridad',
    desc:'Sin SAST, SCA ni hardening del pipeline, el código vulnerable llega a producción sin detección automática.',
    impact:'Vulnerabilidades explotables en producción. Coste de remediación muy elevado.',samm:'SAMM SB1-2'});
  add(radio('si4')===0,{sev:'Medio',dom:'Implementation',practica:'Secure Coding',
    title:'Sin guías de codificación segura',
    desc:'La ausencia de estándares de codificación segura genera vulnerabilidades predecibles.',
    impact:'Inyecciones SQL, XSS, CSRF y otras vulnerabilidades comunes no prevenidas en el código.',samm:'SAMM SC1'});
  add(sc.ver<40,{sev:sc.ver<20?'Crítico':'Alto',dom:'Verification',practica:'Security Testing',
    title:'Sin pruebas de seguridad en el ciclo de desarrollo',
    desc:'Sin DAST, pentests y security gates las vulnerabilidades solo se descubren en producción o por atacantes.',
    impact:'Tiempo de exposición elevado. Vulnerabilidades críticas en producción sin detectar.',samm:'SAMM ST1-2'});
  add(radio('sv3')===0,{sev:'Alto',dom:'Verification',practica:'Defect Management',
    title:'Sin proceso de gestión de vulnerabilidades encontradas',
    desc:'Sin SLAs de remediación, las vulnerabilidades detectadas no se corrigen a tiempo.',
    impact:'Vulnerabilidades críticas permanecen abiertas indefinidamente tras ser identificadas.',samm:'SAMM DM1'});
  add(sc.ops<40,{sev:sc.ops<20?'Crítico':'Alto',dom:'Operations',practica:'Incident Management',
    title:'Sin gestión de incidentes de seguridad en aplicaciones',
    desc:'La ausencia de procesos de respuesta implica tiempos de respuesta elevados y pérdida de evidencias.',
    impact:'Brechas de seguridad no contenidas. Incumplimiento de obligaciones de notificación.',samm:'SAMM IM1'});
  add(radio('so2')===0,{sev:'Alto',dom:'Operations',practica:'Environment Management',
    title:'Sin monitorización de aplicaciones en producción',
    desc:'Sin WAF, RASP o monitorización de logs, los ataques en producción no se detectan.',
    impact:'Ataques exitosos sin detección. Exfiltración de datos silenciosa.',samm:'SAMM EM1'});
  add(radio('so3')===0,{sev:'Medio',dom:'Operations',practica:'Patch Management',
    title:'Sin proceso de gestión de parches con SLAs',
    desc:'Sin tiempos de respuesta definidos, las vulnerabilidades críticas no se parchean con urgencia.',
    impact:'Ventana de explotación prolongada para CVEs conocidos.',samm:'SAMM EM2'});

  var order={Crítico:0,Alto:1,Medio:2,Bajo:3};
  return R.sort(function(a,b){return order[a.sev]-order[b.sev];});
}

var SAMM_ACT={
  'SAMM SM1-2':{action:'Definir estrategia de AppSec, KPIs de madurez SAMM y roadmap anual de mejora',pl:'2 meses',ef:'Alto'},
  'SAMM EG1':{action:'Implantar programa de formación en desarrollo seguro: OWASP Top 10, ASVS, Secure Coding',pl:'1 mes',ef:'Medio'},
  'SAMM TA1-2':{action:'Adoptar Threat Modeling (STRIDE/PASTA) en el proceso de diseño de nuevas funcionalidades',pl:'2 meses',ef:'Medio'},
  'SAMM SR1':{action:'Definir y formalizar requisitos de seguridad por tipo de aplicación basados en OWASP ASVS',pl:'1 mes',ef:'Medio'},
  'SAMM SA1':{action:'Implantar análisis de composición de software (SCA) y gestión de SBOM en el pipeline',pl:'3 semanas',ef:'Bajo'},
  'SAMM SB1-2':{action:'Integrar SAST (SonarQube, Semgrep) y SCA en pipeline CI/CD con quality gates de seguridad',pl:'1 mes',ef:'Medio'},
  'SAMM SC1':{action:'Publicar guías de codificación segura basadas en OWASP Top 10 y CWE Top 25',pl:'2 semanas',ef:'Bajo'},
  'SAMM ST1-2':{action:'Integrar DAST (OWASP ZAP, Burp) en CI/CD y contratar pentest externo anual',pl:'6 semanas',ef:'Medio'},
  'SAMM DM1':{action:'Definir proceso de gestión de vulnerabilidades con SLAs: Crítico 24h, Alto 7d, Medio 30d',pl:'2 semanas',ef:'Bajo'},
  'SAMM IM1':{action:'Desarrollar runbooks de respuesta a incidentes AppSec y entrenar al equipo de desarrollo',pl:'1 mes',ef:'Medio'},
  'SAMM EM1':{action:'Implantar WAF, logging de aplicación y alertas ante patrones de ataque en producción',pl:'6 semanas',ef:'Alto'},
  'SAMM EM2':{action:'Definir política de gestión de parches con SLAs por criticidad CVE',pl:'2 semanas',ef:'Bajo'}
};

function buildSAMMActions(risks){
  return risks.map(function(r,i){
    var a=SAMM_ACT[r.samm];if(!a)return null;
    return {p:i+1,sev:r.sev,action:a.action,samm:r.samm,ef:a.ef,pl:a.pl};
  }).filter(Boolean);
}

function sammUpdateStepper(current){
  for(var i=1;i<=6;i++){
    var el=gid('samm-step-'+i);if(!el)continue;
    var circle=el.querySelector('.psq-step-circle');
    el.className='psq-step';circle.className='psq-step-circle';
    if(i<current){
      el.classList.add('done');circle.classList.add('done');
      circle.innerHTML='<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
    } else if(i===current){
      el.classList.add('active');circle.classList.add('active');circle.textContent=i;
    } else {
      circle.classList.add('pending');circle.textContent=i;
    }
  }
}

function sammShowStage(n){
  for(var i=1;i<=6;i++){var s=gid('samm-stage-'+i);if(s)s.className='psq-stage'+(i===n?' active':'');}
  sammUpdateStepper(n);
  gid('samm-missing').style.display='none';
  scrollToTop();
}

function sammCheckEmail(){
  var el=gid('samm-email'),email=el?el.value.trim():'';
  var valid=email.length>0&&email.indexOf('@')>0&&email.indexOf('.')>0;
  var btn=gid('samm-calc-btn');
  if(btn){btn.disabled=!valid;btn.style.opacity=valid?'1':'0.5';btn.style.cursor=valid?'pointer':'not-allowed';}
}

var sammRadarChart=null;

function sammCalcular(){
  var sc=computeSAMM();
  var ov=overallSAMM(sc);
  var f={
    date:new Date().toLocaleDateString('es-ES'),
    email:txt('samm-email'),client:txt('samm-client'),
    responsible:txt('samm-responsible'),targetDate:txt('samm-date'),scope:txt('samm-scope')
  };
  window._sammRaw={
    sg1:radio('sg1'),sg2:radio('sg2'),sg3:radio('sg3'),sg4:radio('sg4'),sg5:radio('sg5'),
    sd1:radio('sd1'),sd2:radio('sd2'),sd3:radio('sd3'),sd4:radio('sd4'),sd5:radio('sd5'),
    si1:radio('si1'),si2:radio('si2'),si3:radio('si3'),si4:radio('si4'),si5:radio('si5'),
    sv1:radio('sv1'),sv2:radio('sv2'),sv3:radio('sv3'),sv4:radio('sv4'),sv5:radio('sv5'),
    so1:radio('so1'),so2:radio('so2'),so3:radio('so3'),so4:radio('so4'),so5:radio('so5')
  };
  sammEnviarContacto(f,ov);
  sammRenderResults(sc,ov,f);
}

function sammEnviarContacto(f,ov){
  var url=window.CUATRIA_LEADS_URL;if(!url)return;
  fetch(url+'/lead',{method:'POST',headers:{'Content-Type':'application/json'},
    body:JSON.stringify({email:f.email,tool:'samm',score:ov,name:f.responsible||'',client:f.client||'',date:f.date||''})
  }).catch(function(){});
}

function sammRenderResults(sc,ov,f){
  var risks=buildSAMMRisks(sc);
  var actions=buildSAMMActions(risks);
  var cntCrit=risks.filter(function(r){return r.sev==='Crítico';}).length;
  var cntAlto=risks.filter(function(r){return r.sev==='Alto';}).length;
  var col=scoreColor(ov);
  var lbl=scoreLbl(ov);

  var parts=[];
  if(f.client)parts.push('Cliente: <strong>'+f.client+'</strong>');
  if(f.responsible)parts.push(f.responsible);
  parts.push('Fecha: '+f.date);
  gid('samm-r-meta').innerHTML=parts.join(' | ');
  gid('samm-r-score').textContent=ov;gid('samm-r-score').style.color=col;
  gid('samm-r-label').textContent=lbl;gid('samm-r-label').style.background=col;
  gid('samm-cnt-crit').textContent=cntCrit;
  gid('samm-cnt-alto').textContent=cntAlto;
  gid('samm-cnt-act').textContent=actions.length;

  gid('samm-r-chips').innerHTML=SAMM_SECS.map(function(s){
    var v=sc[s.id],c=scoreColor(v);
    return '<div class="psq-chip" style="border:1px solid '+c+'44"><span style="color:#64748b">'+s.short+': </span><span style="color:'+c+';font-weight:700">'+v+'%</span></div>';
  }).join('');

  gid('samm-domain-grid').innerHTML=SAMM_SECS.map(function(s){
    var v=sc[s.id],c=scoreColor(v);
    return '<div class="psq-domain-card" style="border-top-color:'+c+'"><div style="font-size:22px;font-weight:700;color:'+c+'">'+v+'%</div><div style="font-size:11px;font-weight:600;color:#64748b;margin-top:2px">'+s.short+'</div><div style="font-size:10px;color:#94a3b8;margin-top:2px">SAMM</div></div>';
  }).join('');

  setTimeout(function(){
    if(sammRadarChart){sammRadarChart.destroy();sammRadarChart=null;}
    var ctx=gid('samm-radarCanvas').getContext('2d');
    var keys=SAMM_SECS.map(function(s){return s.id;});
    var data=keys.map(function(k){return sc[k];});
    sammRadarChart=new Chart(ctx,{
      type:'radar',
      data:{
        labels:SAMM_SECS.map(function(s){return s.short;}),
        datasets:[
          {label:'Tu organización',data:data,backgroundColor:'rgba(32,201,151,0.12)',borderColor:'#20c997',borderWidth:2,pointBackgroundColor:data.map(function(v){return scoreColor(v);}),pointRadius:4},
          {label:'Nivel 1',data:keys.map(function(k){return SAMM_REF[k].l1;}),backgroundColor:'transparent',borderColor:'#0d6efd',borderWidth:1.5,borderDash:[5,3],pointRadius:2,pointBackgroundColor:'#0d6efd'},
          {label:'Nivel 2',data:keys.map(function(k){return SAMM_REF[k].l2;}),backgroundColor:'transparent',borderColor:'#d97706',borderWidth:1.5,borderDash:[4,2],pointRadius:2,pointBackgroundColor:'#d97706'}
        ]
      },
      options:{responsive:true,maintainAspectRatio:false,
        plugins:{legend:{display:false},tooltip:{callbacks:{label:function(c){return c.dataset.label+': '+c.parsed.r+'%';}}}},
        scales:{r:{min:0,max:100,ticks:{stepSize:25,color:'#94a3b8',font:{size:9},backdropColor:'transparent'},grid:{color:'#e2e8f0'},angleLines:{color:'#e2e8f0'},pointLabels:{color:'#64748b',font:{size:10}}}}
      }
    });
  },80);

  gid('samm-map-tbody').innerHTML=SAMM_SECS.map(function(s){
    var v=sc[s.id],c=scoreColor(v);
    return '<tr>'
      +'<td data-label="Dominio" style="font-weight:600">'+s.label+'</td>'
      +'<td data-label="Puntuación"><span style="font-weight:700;color:'+c+'">'+v+'%</span></td>'
      +'<td data-label="Nivel SAMM"><span style="font-weight:600;color:'+c+'">'+sammLevel(v)+'</span></td>'
      +'<td data-label="OWASP SAMM" style="color:#13795b;font-size:11px">'+s.samm+'</td>'
      +'<td data-label="ISO 27001" style="color:#6f42c1">'+s.iso+'</td>'
      +'<td data-label="Estado"><span style="font-weight:600;color:'+c+'">'+(v>=70?'Adecuado':v>=40?'Mejorable':'Deficiente')+'</span></td>'
      +'</tr>';
  }).join('');

  gid('samm-risk-list').innerHTML=risks.length?risks.map(function(r){
    var c=LEVEL_COLOR[r.sev]||'#64748b';
    return '<div class="psq-risk-item" style="border-color:'+c+'">'
      +'<div style="display:flex;justify-content:space-between;align-items:flex-start;gap:6px;margin-bottom:4px">'
      +'<h4 style="margin:0">'+r.title+'</h4>'+badge(r.sev,c)+'</div>'
      +'<p style="margin:0 0 3px">'+r.desc+'</p>'
      +'<small>'+r.samm+' - '+r.dom+'</small></div>';
  }).join(''):'<p style="color:#16a34a;margin:0">No se han detectado riesgos críticos.</p>';

  gid('samm-risk-tbody').innerHTML=risks.map(function(r,i){
    var c=LEVEL_COLOR[r.sev]||'#64748b';
    return '<tr>'
      +'<td data-label="#" style="color:#64748b">'+(i+1)+'</td>'
      +'<td data-label="Riesgo"><strong>'+r.title+'</strong></td>'
      +'<td data-label="Severidad">'+badge(r.sev,c)+'</td>'
      +'<td data-label="Dominio" style="color:#13795b">'+r.dom+'</td>'
      +'<td data-label="Práctica" style="color:#13795b;font-size:11px">'+r.practica+'</td>'
      +'<td data-label="Impacto" style="color:#64748b;min-width:180px">'+r.impact+'</td>'
      +'</tr>';
  }).join('');

  gid('samm-action-tbody').innerHTML=actions.map(function(a){
    var sc2=LEVEL_COLOR[a.sev]||'#64748b';
    var ec=EFFORT_COLOR[a.ef]||'#64748b';
    return '<tr>'
      +'<td data-label="#" style="color:#20c997;font-weight:700">'+a.p+'</td>'
      +'<td data-label="Severidad">'+badge(a.sev,sc2)+'</td>'
      +'<td data-label="Acción" style="font-weight:600;min-width:200px">'+a.action+'</td>'
      +'<td data-label="Práctica SAMM" style="color:#13795b;font-size:11px;white-space:nowrap">'+a.samm+'</td>'
      +'<td data-label="Esfuerzo">'+badge(a.ef,ec)+'</td>'
      +'<td data-label="Plazo" style="color:#64748b;white-space:nowrap">'+a.pl+'</td>'
      +'</tr>';
  }).join('');

  gid('samm-footer').textContent='Informe generado automáticamente - OWASP SAMM v2 - '+new Date().toLocaleDateString('es-ES',{year:'numeric',month:'long',day:'numeric'});

  window._sammData={f:f,scores:sc,overall:ov,risks:risks,actions:actions,col:col,lbl:lbl};
  gid('samm-form').style.display='none';
  gid('samm-results').style.display='block';
  scrollToTop();
}

function sammGoForm(){
  gid('samm-results').style.display='none';
  gid('samm-form').style.display='block';
  sammShowStage(6);
}

function sammExportPDF(){
  var jsPDF=window.jspdf?window.jspdf.jsPDF:null;if(!jsPDF)return;
  var d=window._sammData;if(!d)return;
  var doc=new jsPDF({orientation:'portrait',unit:'mm',format:'a4'});
  var F='helvetica';
  if(window._psqRobotoB64){
    doc.addFileToVFS('Roboto.ttf',window._psqRobotoB64);
    doc.addFont('Roboto.ttf','Roboto','normal');
    F='Roboto';
  }
  if(window._psqRobotoBoldB64){
    doc.addFileToVFS('Roboto-Bold.ttf',window._psqRobotoBoldB64);
    doc.addFont('Roboto-Bold.ttf','Roboto','bold');
  }

  function generarPDF(imgData,ratio){
    // ── Cabecera ──────────────────────────────────────────────────────────
    doc.setFillColor(32,201,151);doc.rect(0,0,210,28,'F');
    if(imgData){var lH=12,lW=lH*ratio;doc.addImage(imgData,'PNG',210-lW-10,8,lW,lH);}
    doc.setTextColor(255,255,255);doc.setFontSize(15);doc.setFont(F,'bold');
    doc.text('Informe de Madurez - OWASP SAMM v2',14,12);
    doc.setFontSize(8);doc.setFont(F,'normal');
    doc.text('Cliente: '+(d.f.client||'-')+'   |   Responsable: '+(d.f.responsible||'-')+'   |   Fecha: '+d.f.date,14,22);
    doc.setTextColor(30,41,59);doc.setFontSize(13);doc.setFont(F,'bold');
    doc.text('Puntuación Global: '+d.overall+' / 100  -  '+d.lbl,14,38);

    // ── Tabla 1: Dominios ─────────────────────────────────────────────────
    doc.autoTable({startY:44,
      head:[['Dominio','Puntuación','Nivel SAMM','OWASP SAMM','ISO 27001','Estado']],
      body:SAMM_SECS.map(function(s){var v=d.scores[s.id];return[s.label,v+'%',sammLevel(v),s.samm,s.iso,v>=70?'Adecuado':v>=40?'Mejorable':'Deficiente'];}),
      styles:{fontSize:7,font:F},headStyles:{fillColor:[32,201,151],font:F},margin:{left:14,right:14}});

    var y=doc.lastAutoTable.finalY+10;
    doc.setFontSize(12);doc.setFont(F,'bold');doc.setTextColor(220,38,38);
    doc.text('Riesgos Identificados ('+d.risks.length+')',14,y);

    // ── Tabla 2: Riesgos ──────────────────────────────────────────────────
    doc.autoTable({startY:y+2,
      head:[['Riesgo','Severidad','Dominio','Práctica','Impacto']],
      body:d.risks.map(function(r){return[r.title,r.sev,r.dom,r.practica,r.impact];}),
      styles:{fontSize:7,cellPadding:3,font:F},headStyles:{fillColor:[220,38,38],font:F},margin:{left:14,right:14},columnStyles:{4:{cellWidth:50}}});

    y=doc.lastAutoTable.finalY+10;
    doc.setTextColor(32,201,151);doc.setFontSize(12);doc.setFont(F,'bold');
    doc.text('Plan de Acción Priorizado',14,y);

    // ── Tabla 3: Plan de Acción ───────────────────────────────────────────
    doc.autoTable({startY:y+2,
      head:[['#','Severidad','Acción','Práctica SAMM','Esfuerzo','Plazo']],
      body:d.actions.map(function(a){return[a.p,a.sev,a.action,a.samm,a.ef,a.pl];}),
      styles:{fontSize:7,cellPadding:3,font:F},headStyles:{fillColor:[32,201,151],font:F},margin:{left:14,right:14},columnStyles:{2:{cellWidth:60}}});

    y=doc.lastAutoTable.finalY+14;
    if(y>240){doc.addPage();y=20;}
    doc.setTextColor(3,105,161);doc.setFontSize(12);doc.setFont(F,'bold');
    doc.text('Anexo: Respuestas al cuestionario',14,y);
    doc.setFontSize(8);doc.setFont(F,'normal');doc.setTextColor(100,116,139);
    doc.text('Evidencia de las respuestas proporcionadas por el usuario.',14,y+5);

    var labels={2:'Sí, nivel alto',1:'Parcialmente / nivel medio',0:'No / nivel bajo'};
    var rows=[
      ['1','Estrategia y métricas de seguridad documentadas',labels[window._sammRaw.sg1]],
      ['2','Evaluaciones de riesgo específicas para aplicaciones',labels[window._sammRaw.sg2]],
      ['3','Formación periódica en seguridad al equipo de desarrollo',labels[window._sammRaw.sg3]],
      ['4','Responsable o equipo dedicado a seguridad del software',labels[window._sammRaw.sg4]],
      ['5','Reporte de seguridad del software a la dirección',labels[window._sammRaw.sg5]],
      ['6','Modelado de amenazas (Threat Modeling) en el diseño',labels[window._sammRaw.sd1]],
      ['7','Requisitos de seguridad documentados antes de desarrollo',labels[window._sammRaw.sd2]],
      ['8','Patrones de diseño seguro y arquitecturas de referencia',labels[window._sammRaw.sd3]],
      ['9','Evaluación de componentes y librerías de terceros (SCA)',labels[window._sammRaw.sd4]],
      ['10','Principios de privacidad en el diseño (Privacy by Design)',labels[window._sammRaw.sd5]],
      ['11','Revisiones de código seguro (Code Review)',labels[window._sammRaw.si1]],
      ['12','Análisis estático de seguridad (SAST) en CI/CD',labels[window._sammRaw.si2]],
      ['13','Gestión de dependencias y vulnerabilidades (SCA/SBOM)',labels[window._sammRaw.si3]],
      ['14','Guías de codificación segura (OWASP Top 10, CWE)',labels[window._sammRaw.si4]],
      ['15','Securización del pipeline de build y despliegue',labels[window._sammRaw.si5]],
      ['16','Pruebas de seguridad dinámicas (DAST) en pre-producción',labels[window._sammRaw.sv1]],
      ['17','Pentests o hacking ético sobre aplicaciones',labels[window._sammRaw.sv2]],
      ['18','Proceso formal de gestión y remediación de vulnerabilidades',labels[window._sammRaw.sv3]],
      ['19','Verificación de requisitos de seguridad antes de producción',labels[window._sammRaw.sv4]],
      ['20','Revisiones de arquitectura de seguridad',labels[window._sammRaw.sv5]],
      ['21','Gestión de incidentes de seguridad en aplicaciones',labels[window._sammRaw.so1]],
      ['22','Monitorización de aplicaciones en producción',labels[window._sammRaw.so2]],
      ['23','Gestión de parches con SLAs definidos',labels[window._sammRaw.so3]],
      ['24','Programa de divulgación responsable (Responsible Disclosure)',labels[window._sammRaw.so4]],
      ['25','Entornos de producción hardening y separados',labels[window._sammRaw.so5]]
    ];

    // ── Tabla 4: Anexo ────────────────────────────────────────────────────
    doc.autoTable({startY:y+9,head:[['#','Pregunta','Respuesta']],body:rows,
      styles:{fontSize:8,cellPadding:3,font:F},headStyles:{fillColor:[32,201,151],font:F},
      columnStyles:{0:{cellWidth:10},2:{cellWidth:45,fontStyle:'bold'}},
      alternateRowStyles:{fillColor:[248,250,252]},margin:{left:14,right:14}});

    // ── Pie de página ─────────────────────────────────────────────────────
    var pages=doc.getNumberOfPages();
    var disc='Este documento es el resultado de un autodiagnóstico realizado por el propio usuario. Zerolynx no garantiza la exactitud de los resultados ni se hace responsable de las decisiones adoptadas en base a este informe.';
    for(var i=1;i<=pages;i++){doc.setPage(i);doc.setFontSize(6);doc.setFont(F,'normal');doc.setTextColor(148,163,184);doc.text(disc,14,289,{maxWidth:182});doc.text('Pág. '+i+'/'+pages,196,292,{align:'right'});}
    var now=new Date();var mm=String(now.getMonth()+1).padStart(2,'0');var yyyy=now.getFullYear();
    doc.save(yyyy+'-'+mm+'-InformeDesarrolloSeguro.pdf');
  }

  var img=new Image();img.crossOrigin='anonymous';
  img.onload=function(){var canvas=document.createElement('canvas');var maxW=320;var ratio=img.width/img.height;canvas.width=maxW;canvas.height=Math.round(maxW/ratio);canvas.getContext('2d').drawImage(img,0,0,canvas.width,canvas.height);generarPDF(canvas.toDataURL('image/png'),ratio);};
  img.onerror=function(){generarPDF(null,0);};
  img.src='https://cdn.shopify.com/s/files/1/0803/8658/9019/files/Zerolynx_Blanco_c5b3b306-c3fd-4960-857e-23bc5247a9c2.png?v=1775764507';
}

document.addEventListener('DOMContentLoaded',function(){
  var emailEl=gid('samm-email');
  if(emailEl){emailEl.addEventListener('input',sammCheckEmail);emailEl.addEventListener('keyup',sammCheckEmail);}
  document.querySelectorAll('#samm-form .psq-yn').forEach(function(g){
    g.addEventListener('change',function(){
      g.querySelectorAll('label').forEach(function(l){l.classList.toggle('sel',!!(l.querySelector('input')&&l.querySelector('input').checked));});
    });
  });
});

window.sammNextStage=function(n){sammShowStage(n+1);};
window.sammPrevStage=function(n){sammShowStage(n-1);};
window.sammCalcular=sammCalcular;
window.sammGoForm=sammGoForm;
window.sammExportPDF=sammExportPDF;
window.showLanding=window.showLanding||function(){};

window.sammInit=function(){
  var emailEl=document.getElementById('samm-email');
  if(emailEl&&!emailEl._inited){
    emailEl._inited=true;
    emailEl.addEventListener('input',sammCheckEmail);
    emailEl.addEventListener('keyup',sammCheckEmail);
  }
  document.querySelectorAll('#psq-samm-wrap .psq-yn').forEach(function(g){
    if(!g._inited){
      g._inited=true;
      g.addEventListener('change',function(){
        g.querySelectorAll('label').forEach(function(l){
          l.classList.toggle('sel',!!(l.querySelector('input')&&l.querySelector('input').checked));
        });
      });
    }
  });
};

})();